<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)" class="form-view">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title">
                  {{ $t("user.profile") }}
                </h4>
              </div>
            </md-card-header>
            <div class="edit-btn-container">
              <a
                data-toggle="dropdown"
                class="edit-btn"
                @click="enableModeEdit()"
              >
                <i class="fa fa-pen fa-2x"> </i>
                <p class="content-button">{{ $t("common.edit") }}</p>
              </a>
            </div>
            <md-card-content>
              <div class="md-layout" style="text-align: center">
                <!-- Avatar -->
                <!--                <div class="md-layout-item md-size-100">-->
                <!--                  <h4 class="card-title">{{ $t("user.avatar") }}</h4>-->
                <!--                  <div class="file-input img-circle">-->
                <!--                    <template v-if="!imageCircle">-->
                <!--                      <div class="image-fix-container">-->
                <!--                        <img :src="avatarImg" title="" />-->
                <!--                      </div>-->
                <!--                    </template>-->
                <!--                    <div class="image-fix-container" v-else>-->
                <!--                      <img :src="imageCircle" />-->
                <!--                    </div>-->
                <!--                    <div class="button-container" v-if="isEditMode">-->
                <!--                      <md-button-->
                <!--                        class="md-success md-round md-fileinput"-->
                <!--                        @click="onFileChange"-->
                <!--                      >-->
                <!--                        <template v-if="!imageCircle">{{-->
                <!--                          $t("user.add_avatar")-->
                <!--                        }}</template>-->
                <!--                        <template v-else>{{-->
                <!--                          $t("user.change_avatar")-->
                <!--                        }}</template>-->
                <!--                      </md-button>-->
                <!--                    </div>-->
                <!--                  </div>-->
                <!--                </div>-->
                <div class="md-layout-item md-size-100 md-xsmall-size-100">
                  <div class="md-layout">
                    <!-- Role -->
                    <!--                    <div class="md-layout-item md-size-100 md-small-size-100">-->
                    <!--                      <div class="md-layout">-->
                    <!--                        <label-->
                    <!--                          class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label "-->
                    <!--                        >-->
                    <!--                          {{ $t("user.role") }}-->
                    <!--                        </label>-->
                    <!--                        <div-->
                    <!--                          class="md-layout-item md-size-80 md-small-size-100"-->
                    <!--                        >-->
                    <!--                          <md-field>-->
                    <!--                            <md-input-->
                    <!--                              v-model="roleNames"-->
                    <!--                              disabled="disabled"-->
                    <!--                            ></md-input>-->
                    <!--                          </md-field>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </div>-->

                    <!-- Username -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <label
                          class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label  required-field"
                        >
                          {{ $t("user.username") }}
                        </label>
                        <div class="md-layout-item md-xsmall-size-100">
                          <ValidationProvider
                            :name="$t('user.username')"
                            rules="required|min:6|max:20|notIncludeSpecialChar"
                            v-slot="{ passed, failed, errors }"
                          >
                            <md-field
                              :class="[
                                { 'md-error': failed },
                                { 'md-valid': passed }
                              ]"
                            >
                              <md-input
                                v-model="params.username"
                                type="text"
                                ref="username"
                                :disabled="!isEditMode"
                              ></md-input>

                              <slide-y-down-transition>
                                <md-icon class="error" v-show="failed"
                                  >close
                                </md-icon>
                              </slide-y-down-transition>
                              <slide-y-down-transition>
                                <md-icon class="success" v-show="passed"
                                  >done
                                </md-icon>
                              </slide-y-down-transition>
                            </md-field>
                            <div class="validate-error">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>

                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <label
                          class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label"
                        >
                          {{ $t("auth.password") }}
                        </label>
                        <div class="md-layout-item md-xsmall-size-100">
                          <ValidationProvider
                            :name="$t('auth.password')"
                            v-slot="{ passed, failed, errors }"
                          >
                            <md-field
                              :class="[
                                { 'md-error': failed },
                                { 'md-valid': passed }
                              ]"
                            >
                              <md-input
                                v-model="params.password"
                                type="text"
                                ref="password"
                                :disabled="!isEditMode"
                              ></md-input>
                            </md-field>
                            <div class="validate-error">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>

                    <!-- Password before edit-->
                    <!--                    <div class="md-layout-item md-size-100" v-if="isEditMode">-->
                    <!--                      <div class="md-layout">-->
                    <!--                        <label-->
                    <!--                          class="md-layout-item md-size-20 md-xsmall-size-100 md-form-label required-field"-->
                    <!--                        >-->
                    <!--                          {{ $t("auth.password") }}-->
                    <!--                        </label>-->
                    <!--                        <div-->
                    <!--                          class="md-layout-item md-size-80 md-xsmall-size-100"-->
                    <!--                        >-->
                    <!--                          <div class="md-layout">-->
                    <!--                            <div-->
                    <!--                              class="md-layout-item md-size-60 md-xsmall-size-100 no-padding"-->
                    <!--                            >-->
                    <!--                              <md-field>-->
                    <!--                                <md-input-->
                    <!--                                  v-model="params.password"-->
                    <!--                                  type="password"-->
                    <!--                                  disabled=""-->
                    <!--                                ></md-input>-->
                    <!--                              </md-field>-->
                    <!--                            </div>-->
                    <!--                            <div-->
                    <!--                              class="md-layout-item md-size-40 md-xsmall-size-100 no-padding"-->
                    <!--                            >-->
                    <!--                              <md-button-->
                    <!--                                native-type="button"-->
                    <!--                                @click="resetPassword()"-->
                    <!--                                class="btn-issue-a-new-password"-->
                    <!--                              >-->
                    <!--                                {{ $t("user.issue_a_new_password") }}-->
                    <!--                              </md-button>-->
                    <!--                            </div>-->
                    <!--                          </div>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </div>-->

                    <!-- Password after edit-->
                    <!--                    <div class="md-layout-item md-size-100" v-if="!isEditMode">-->
                    <!--                      <div class="md-layout">-->
                    <!--                        <label-->
                    <!--                          class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label  required-field"-->
                    <!--                        >-->
                    <!--                          {{ $t("auth.password") }}-->
                    <!--                        </label>-->
                    <!--                        <div class="md-layout-item md-xsmall-size-100">-->
                    <!--                          <ValidationProvider-->
                    <!--                            :name="$t('auth.password')"-->
                    <!--                            rules="required|min:8|max:20"-->
                    <!--                            v-slot="{ passed, failed, errors }"-->
                    <!--                          >-->
                    <!--                            <md-field-->
                    <!--                              :class="[-->
                    <!--                                { 'md-error': failed },-->
                    <!--                                { 'md-valid': passed }-->
                    <!--                              ]"-->
                    <!--                            >-->
                    <!--                              <md-input-->
                    <!--                                v-model="params.password"-->
                    <!--                                type="text"-->
                    <!--                                disabled=""-->
                    <!--                              ></md-input>-->

                    <!--                              <slide-y-down-transition>-->
                    <!--                                <md-icon class="error" v-show="failed"-->
                    <!--                                  >close-->
                    <!--                                </md-icon>-->
                    <!--                              </slide-y-down-transition>-->
                    <!--                              <slide-y-down-transition>-->
                    <!--                                <md-icon class="success" v-show="passed"-->
                    <!--                                  >done-->
                    <!--                                </md-icon>-->
                    <!--                              </slide-y-down-transition>-->
                    <!--                            </md-field>-->
                    <!--                            <div class="validate-error">{{ errors[0] }}</div>-->
                    <!--                          </ValidationProvider>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                    <!-- Email -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <label
                          class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label  required-field"
                        >
                          {{ $t("user.email") }}
                        </label>
                        <div class="md-layout-item md-xsmall-size-100">
                          <ValidationProvider
                            :name="$t('user.email')"
                            rules="email|max:50|required"
                            v-slot="{ passed, failed, errors }"
                          >
                            <md-field
                              :class="[
                                { 'md-error': failed },
                                { 'md-valid': passed }
                              ]"
                            >
                              <md-input
                                v-model.trim="params.email"
                                type="text"
                                :disabled="!isEditMode"
                              ></md-input>

                              <slide-y-down-transition>
                                <md-icon class="error" v-show="failed"
                                  >close
                                </md-icon>
                              </slide-y-down-transition>
                              <slide-y-down-transition>
                                <md-icon class="success" v-show="passed"
                                  >done
                                </md-icon>
                              </slide-y-down-transition>
                            </md-field>
                            <div class="validate-error">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <!-- First Name -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <label
                          class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label "
                        >
                          {{ $t("user.first_name") }}
                        </label>
                        <div class="md-layout-item md-xsmall-size-100">
                          <ValidationProvider
                            :name="$t('user.first_name')"
                            rules="max:50"
                            v-slot="{ passed, failed, errors }"
                          >
                            <md-field
                              :class="[
                                { 'md-error': failed },
                                { 'md-valid': passed }
                              ]"
                            >
                              <md-input
                                v-model="params.first_name"
                                type="text"
                                :disabled="!isEditMode"
                              ></md-input>

                              <slide-y-down-transition>
                                <md-icon class="error" v-show="failed"
                                  >close
                                </md-icon>
                              </slide-y-down-transition>
                              <slide-y-down-transition>
                                <md-icon class="success" v-show="passed"
                                  >done
                                </md-icon>
                              </slide-y-down-transition>
                            </md-field>
                            <div class="validate-error">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <!-- Last Name -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <label
                          class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label "
                        >
                          {{ $t("user.last_name") }}
                        </label>
                        <div class="md-layout-item md-xsmall-size-100">
                          <ValidationProvider
                            :name="$t('user.last_name')"
                            rules="max:50"
                            v-slot="{ passed, failed, errors }"
                          >
                            <md-field
                              :class="[
                                { 'md-error': failed },
                                { 'md-valid': passed }
                              ]"
                            >
                              <md-input
                                v-model="params.last_name"
                                type="text"
                                :disabled="!isEditMode"
                              ></md-input>

                              <slide-y-down-transition>
                                <md-icon class="error" v-show="failed"
                                  >close
                                </md-icon>
                              </slide-y-down-transition>
                              <slide-y-down-transition>
                                <md-icon class="success" v-show="passed"
                                  >done
                                </md-icon>
                              </slide-y-down-transition>
                            </md-field>
                            <div class="validate-error">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </md-card-content>
            <md-card-actions class="text-center" v-if="isEditMode">
              <md-button type="submit" class="md-success"
                >{{ $t("user.save") }}
              </md-button>
              <md-button native-type="button" @click="cancel"
                >{{ $t("common.cancel") }}
              </md-button>
            </md-card-actions>
          </md-card>
        </form>
      </ValidationObserver>
    </div>

    <crop-upload-image-modal
      :modal-data="modalAvatar"
      :origin-img-src="imageCircle"
      :min-container-width="340"
      :min-container-height="260"
      :background="true"
      :rotatable="false"
      :img-style="{ width: '320px', height: '220px' }"
      :aspect-ratio="1"
      :click-outside-to-close="false"
      @closeModal="closeModalChangeAvatar"
      @setCroppedImageSrc="updateAvatar"
    ></crop-upload-image-modal>

    <confirm-modal
      :modal-data="modalData"
      :confirm-text="confirmText"
      :btn-ok-text="btnOkText"
      :btn-cancel-text="btnCancelText"
      @closeModal="closeModal"
      @confirm="confirmOk"
    >
    </confirm-modal>
  </div>
</template>
<script>
import CropUploadImageModal from "../../components/VueUploadMultipleImage/CropUploadImageModal";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import { UserService } from "../../services/user.service";

export default {
  name: "ViewUser",
  components: {
    ConfirmModal,
    CropUploadImageModal
  },
  props: {
    avatarImg: {
      type: String,
      default: "../img/image_placeholder.jpg"
    }
  },
  data() {
    return {
      modalAvatar: {
        show: false,
        action: "create"
      },
      modalData: {
        show: false,
        action: "create"
      },
      confirmText: null,
      btnOkText: null,
      btnCancelText: null,
      roles: [],
      characters: "a-z,A-Z,0-9",
      isInit: true,
      isEditMode: false,
      roleName: null,
      imageCircle: "",
      picture: null,
      roleNames: null,
      roleId: null,
      params: {
        username: null,
        email: null,
        first_name: null,
        last_name: null,
        password: null
      }
    };
  },
  methods: {
    submit() {
      this.updateUser();
    },
    async updateUser() {
      let formData = this.buildFormDataUpdateUser();
      const response = await new UserService().update(
        this.$route.params.id,
        formData
      );
      if (!response) return;

      this.$notify({
        title: this.$t("user.updated"),
        text: this.$t("user.updated_text", {
          name: ""
        }),
        type: "success"
      });
      this.isEditMode = false;
    },
    buildFormDataUpdateUser() {
      let params = {
        ...this.params,
        picture: this.picture
      };

      if (!params.password) delete params.password;
      if (!params.name) delete params.name;
      if (!params.email) delete params.email;
      if (!params.picture) delete params.picture;

      return params;
    },
    closeModal() {
      this.modalData.show = false;
    },
    confirmOk() {
      this.closeModal();
    },
    async getProfile() {
      let userInfo = await new UserService().getById(this.$route.params.id);
      this.params.username = userInfo.username;
      this.params.first_name = userInfo.first_name;
      this.params.last_name = userInfo.last_name;
      this.params.email = userInfo.email;
      // this.params.phone_number = userInfo.phone_number;
      // this.roleName = userInfo.roles.length > 0 ? userInfo.roles[0].name : null;
      //  get role user
      // this.roles = userInfo.roles;
      // let roleNames = [];
      // userInfo.roles.forEach(role => {
      //   roleNames.push(role.name);
      // });
      // this.roleNames = roleNames.join(", ");
      //
      // //  get avatar image
      // if (userInfo.picture !== null && userInfo.picture !== "") {
      //   this.imageCircle = userInfo.picture;
      // }
    },
    resetPassword() {
      let charactersArray = this.characters.split(",");
      let CharacterSet = "";
      let password = "";

      if (charactersArray.indexOf("a-z") >= 0) {
        CharacterSet += "abcdefghijklmnopqrstuvwxyz";
      }
      if (charactersArray.indexOf("A-Z") >= 0) {
        CharacterSet += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      }
      if (charactersArray.indexOf("0-9") >= 0) {
        CharacterSet += "01234567890123456789";
      }
      for (let i = 0; i < 15; i++) {
        password += CharacterSet.charAt(
          Math.floor(Math.random() * CharacterSet.length)
        );
      }
      this.params.password = password;
    },
    enableModeEdit() {
      this.isEditMode = !this.isEditMode;
    },
    onFileChange(e) {
      this.showModalChangeAvatar("edit");
    },
    updateAvatar(file) {
      this.picture = file;
      this.createImage(file, "circle");
    },
    createImage(file, type) {
      let reader = new FileReader();
      let vm = this;

      reader.onload = e => {
        if (type === "circle") {
          vm.imageCircle = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    },
    closeModalChangeAvatar() {
      this.modalAvatar.show = false;
      this.$store.commit("DESTROY_MODAL");
    },
    showModalChangeAvatar(action) {
      this.modalAvatar.action = action || "create";
      this.modalAvatar.show = true;
      this.$store.commit("SHOW_MODAL");
    },
    cancel() {
      this.getProfile();
      this.isEditMode = false;
    }
  },
  mounted() {
    this.getProfile();
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.text-center {
  justify-content: center !important;
}

.md-field .success.md-icon,
.md-field .error.md-icon {
  right: -20px;
}

.content-button {
  margin: 0;
}

.edit-btn-container {
  text-align: right;
  margin: 10px 40px;
}

.edit-btn-container a {
  display: inline-block;
  text-align: center;
}

.edit-btn-container a:hover {
  cursor: pointer;
}

.edit-btn-container a i {
  padding: 10px;
  background: #9c27b0;
  border-radius: 10px;
}

.edit-btn-container a i.fa-pen:before {
  color: #ffffff;
}

.image-fix-container {
  max-width: 250px;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 10px;
  box-shadow: 0 10px 30px -12px rgb(0 0 0 / 42%), 0 4px 25px 0 rgb(0 0 0 / 12%),
    0 8px 10px -5px rgb(0 0 0 / 20%);
}

.btn-issue-a-new-password {
  background: linear-gradient(60deg, #ec407a, #d81b60);
}
</style>
